/**
 * KS STICKY ATC BAR
 * Stand: KS-BUILD-V6.6.5.5
 *
 * Best Practice:
 * - Nur auf Mobile (max 767px)
 * - Bar erscheint erst wenn BEIDE Bedingungen erfuellt:
 *   1. User hat nach unten gescrollt (scrollY > Schwellenwert)
 *   2. Originaler ATC-Button ist nicht im Viewport
 * - Variantenstatus wird gespiegelt
 * - Klick sendet das bestehende Produktformular mit der gewählten Variante ab
 */
(function () {
  'use strict';

  function initStickyATC() {
    if (window.innerWidth > 767) return;

    var originalBtn = document.querySelector('.product-single__form .add-to-cart');
    if (!originalBtn) return;

    /* Bar aufbauen */
    var bar = document.createElement('div');
    bar.className = 'ks-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.setAttribute('role', 'complementary');
    bar.setAttribute('aria-label', 'Schnellkauf');
    bar.setAttribute('inert', '');

    var info = document.createElement('div');
    info.className = 'ks-sticky-atc__info';

    var stickyBtn = document.createElement('button');
    var productForm = originalBtn.form;
    var productFormId = productForm && productForm.getAttribute('id');
    stickyBtn.type = productFormId ? 'submit' : 'button';
    if (productFormId) stickyBtn.setAttribute('form', productFormId);
    stickyBtn.className = 'ks-sticky-atc__btn';
    stickyBtn.textContent = 'In den Warenkorb';
    stickyBtn.tabIndex = -1;

    bar.appendChild(info);
    bar.appendChild(stickyBtn);
    document.body.appendChild(bar);

    /* Status vom originalen Button spiegeln */
    function syncState() {
      var isDisabled = originalBtn.disabled ||
        originalBtn.classList.contains('disabled') ||
        originalBtn.classList.contains('is-added');
      var originalText = originalBtn.querySelector('[data-add-to-cart-text]');
      var buttonText = String(
        originalText ? originalText.textContent : originalBtn.textContent
      ).trim();
      stickyBtn.disabled = isDisabled;
      stickyBtn.textContent = buttonText || (isDisabled ? 'Nicht verfügbar' : 'In den Warenkorb');
      stickyBtn.setAttribute('aria-label', stickyBtn.textContent);
      updateVisibility();
    }
    syncState();

    var mo = new MutationObserver(syncState);
    mo.observe(originalBtn, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    /* Zustandsverwaltung */
    var hasScrolled = false;      /* Hat der User nach unten gescrollt? */
    var btnOutOfView = false;     /* Ist der originale Button nicht sichtbar? */
    /* Schwellenwert: erst nach 120px Scroll wird die Bar ueberhaupt aktiv */
    var SCROLL_THRESHOLD = 120;

    function updateVisibility() {
      /* Ein deaktivierter Schnellkauf ist eine Sackgasse und verdeckt auf
         ausverkauften PDPs den hilfreichen Benachrichtigungs-CTA. */
      var isVisible = hasScrolled && btnOutOfView && !stickyBtn.disabled;

      if (isVisible) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
        bar.removeAttribute('inert');
        stickyBtn.tabIndex = 0;
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        bar.setAttribute('inert', '');
        stickyBtn.tabIndex = -1;
      }
    }

    /* Scroll-Listener: prueft ob User weit genug gescrollt hat */
    function onScroll() {
      hasScrolled = window.scrollY > SCROLL_THRESHOLD;
      updateVisibility();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    /* Initial pruefen (z.B. bei page-restore mit Scroll-Position) */
    onScroll();

    /* IntersectionObserver: prueft ob ATC-Button sichtbar ist */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            btnOutOfView = !entry.isIntersecting;
            updateVisibility();
          });
        },
        {
          /* rootMargin: negativer Bottom-Wert damit der Button
             als 'out of view' gilt bevor er komplett verschwindet */
          rootMargin: '0px 0px -20px 0px',
          threshold: 0.1
        }
      );
      io.observe(originalBtn);
    }

    /* Als echter Submit-Button ist der Sticky-CTA direkt mit demselben
       Produktformular verbunden. Damit verarbeitet der vorhandene Theme-
       AJAX-Handler Klick, Tastatur und die gewaehlte Variante identisch.
       Nur fuer Themes ohne Formular-ID bleibt ein direkter Fallback. */
    if (!productFormId) {
      stickyBtn.addEventListener('click', function () {
        if (!stickyBtn.disabled) originalBtn.click();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }

})();
